<n-data-table
    #dt
    [columnDefs]="tableColumnDefs"
    [config]="tableConfig"
    [data]="shareData"
    [loading]="loading || updateLoading"
    id="file-system-share-table">
</n-data-table>
